import React from "react";
import { Fstyr } from "../../components/FstyrComponents/Fstyr.js";
import { fetchModel } from "../../components/HelperComponents/FetchExtension";
import URL from "../../Constants/URL.js";
import { ControlCardVm } from "../../Models/ControlCardVm";
import { DateFormatter } from "../../components/HelperComponents/DateFormatter";
import { GetStatusName } from "../../components/HelperComponents/StatusHelper";
import { sortCardTableByDate } from "../../components/HelperComponents/Helpers";
import { ValidationType } from "../../Constants/ValidationTypes";
import { Link } from "react-router-dom";

type Props = {};

type State = {
  wrxNumberInput: string;
  wrxNumberIsValid: boolean;
  searchButtonPressed: boolean;

  showSpinner: boolean;

  tableResults: (JSX.Element | string)[][];
};

export class SearchControlWrx extends React.Component<Props, State> {
  private toastRef: React.RefObject<any>;

  constructor(props: Props) {
    super(props);
    this.toastRef = React.createRef();

    this.state = {
      wrxNumberInput: "",
      wrxNumberIsValid: false,
      searchButtonPressed: false,

      showSpinner: false,

      tableResults: [],
    };
  }

  handleSearch() {
    this.setState({ searchButtonPressed: true });
    this.clearPage(false);
    if (this.state.wrxNumberIsValid) {
      this.setState({ showSpinner: true });
      //possible fetch politibetjent
      this.fetchControlCards();
    }
  }

  fetchControlCards() {
    fetchModel("GET", URL + "/api/controlcard/GetControlCardsByWrxNr", this.state.wrxNumberInput, ControlCardVm)
      .then((model) => {
        this.handleControlCardSearchResults(model);
      })
      .catch((error) => this.showErrorToast(error, "et kontrolkort"))
      .finally(() => {
        this.setState({ showSpinner: false });
      });
  }

  handleControlCardSearchResults(result: ControlCardVm[]) {
    result = sortCardTableByDate(result);
    this.setState({
      tableResults: result.map((controlCard) => {
        return [
          <Link target="_blank" to={`/controlcard/searchControlG2V2/${controlCard.CardNumber}`}>
            {controlCard.CardNumber}
          </Link>,
          `${controlCard.Authority.PlaceOfIssue}`,
          DateFormatter(controlCard.ValidFrom),
          DateFormatter(controlCard.ValidTo),
          GetStatusName(controlCard.Status.Id),
        ];
      }),
    });
  }

  clearPage(clearInput: boolean) {
    this.setState({
      showSpinner: false,
      tableResults: [],
    });

    if (clearInput) {
      this.setState({
        searchButtonPressed: false,
        wrxNumberIsValid: false,
        wrxNumberInput: "",
      });
    }
  }

  showErrorToast(error: string, msg: string) {
    this.setState({ showSpinner: false });
    if (error === "No result") {
      this.toastRef.current.show("Kontrolkort", `Der findes ikke ${msg} med det søgte nummer`, "warning");
    } else if (error === "Failed response") {
      this.toastRef.current.show("Fejl", "Kan ikke forbinde til databasen", "error");
    } else {
      this.toastRef.current.show("Fejl", "Der skete en ukendt fejl", "error");
    }
  }

  render() {
    return (
      <>
        <Fstyr.Toast ref={this.toastRef} />
        <Fstyr.Segment title="Søg Kontrolkort" isPageTitle={true}>
          <div className="fstyr-right-top-button-group">
            <Fstyr.Button
              label="Ryd side"
              onClick={() => {
                this.clearPage(true);
              }}
            />
          </div>
        </Fstyr.Segment>
        <Fstyr.Segment title={`Angiv ID-nummer`}>
          <Fstyr.Input
            value={this.state.wrxNumberInput}
            label="ID-nummer"
            onChange={(value: string) => this.setState({ wrxNumberInput: value })}
            validation={true}
            validationType={ValidationType.wrxNr}
            errorBodyText={"Skal være mellem 4 og 10 cifre langt"}
            errorExampleText={"f.eks. 01AB901234"}
            onEnterPressed={() => this.handleSearch()}
            setValid={(valid: boolean) => this.setState({ wrxNumberIsValid: valid })}
            buttonClicked={this.state.searchButtonPressed}
            onValidatingButtonPressed={() => this.setState({ searchButtonPressed: true })}
          />

          <div className="fstyr-left-button-group">
            <Fstyr.Button
              label="Søg"
              onClick={() => {
                this.handleSearch();
              }}
              disabled={this.state.showSpinner}
            />
            <div style={{ width: 20 }} />
            <Fstyr.Spinner show={this.state.showSpinner} />
          </div>
        </Fstyr.Segment>
        <Fstyr.Segment title="Resultater">
          <Fstyr.Table label="Registreret kontrolkort" headers={["Kortnr.", "Kontrolmyndighed", "Startdato", "Udløbsdato", "Status"]} data={this.state.tableResults} note={"Betjenten har " + this.state.tableResults.length + " registreringer på kontrolkort"} />
        </Fstyr.Segment>
      </>
    );
  }
}
